/**
*
*   Signup Footer
*       - The Signup Area on the Footer
*
**/
'use client';

import Config from '@/config';
import { Link } from '@/components/link';
import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';



//Build the Element
export default function SocialShare({ title , image , excerpt, ...props }){

	const t = useTranslations();
	const path = usePathname();

	const Links = {
		twitter: () => `http://x.com/share?text=${  title  }&url=${  Config.domain  }${ path }`,
		facebook: () => `https://www.facebook.com/sharer/sharer.php?u=${  Config.domain  }${ path }`,
		pinterest: () => `http://pinterest.com/pin/create/button/?url=${  Config.domain  }${ path  }&media=${  image  }&description=${  excerpt }`
	};

	//Return
	return (
		<div className="share">
			<span>{ t('Pages.Blog.share') }:</span>
			<Link href={ Links.twitter() } target="_blank">
				<i aria-hidden="true" className="fa-brands fa-square-x-twitter"></i>
			</Link>
			<Link href={ Links.facebook() } target="_blank">
				<i aria-hidden="true" className="fab fa-facebook-square"></i>
			</Link>
			<Link href={ Links.pinterest() }>
				<i aria-hidden="true" className="fab fa-pinterest-square"></i>
			</Link>
		</div>
	);

}